import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import "./App.css";
import { AllPages } from "./routes";
import "./scss/index.scss";
import { getStore } from "./store-redux";
import { Provider } from "react-redux";
import { SnackbarMessage } from "./components/SnackbarMessage";
import Authorization from "./components/Authorization";
import QueryProvider from "./providers/QueryClientProvider";
import { useSelector } from "react-redux";
import { IApplicationState } from "./store-redux";
import { useNotificationSocket } from "./hooks/useNotificationSocket";
import { NotificationCenter } from "./components/NotificationCenter";
import { GlobalAiUpgradeWidget } from "./components/GlobalAiUpgradeWidget";
import { BrowserRecommendationBanner } from "./components/BrowserRecommendationBanner";
import { UserReportWidget } from "./components/UserReportWidget";
import MaintenancePage from "./pages/MaintenancePage";

// ⚠️ Đổi giá trị thành true khi muốn bật chế độ bảo trì toàn hệ thống
const IS_MAINTENANCE_MODE = false;

const AppSelector: React.FC = () => {
  const appMode = useSelector((state: IApplicationState) => state.appMode);
  const isDark = appMode === "dark";

  // Connect to Socket.IO for real-time notifications
  useNotificationSocket();

  const theme = createTheme({
    palette: {
      mode: appMode,
      primary: {
        main: "#0D9488", // Teal 600
      },
      secondary: {
        main: isDark ? "#94A3B8" : "#1E293B",
      },
      background: {
        default: isDark ? "#020617" : "#F8FAFC",
        paper: isDark ? "#0F172A" : "#FFFFFF",
      },
    },
    typography: {
      fontFamily: ["Nunito", "sans-serif"].join(","),
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryProvider>
        {IS_MAINTENANCE_MODE ? (
          <MaintenancePage />
        ) : (
          <>
            <SnackbarMessage />
            <NotificationCenter />
            <GlobalAiUpgradeWidget />
            <BrowserRecommendationBanner />
            <UserReportWidget />
            <Authorization>
              <AllPages />
            </Authorization>
          </>
        )}
      </QueryProvider>
    </ThemeProvider>
  );
};

import { BrowserRouter } from "react-router-dom";

function App() {
  return (
    <Provider store={getStore({})}>
      <BrowserRouter>
        <AppSelector />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
